import { render, staticRenderFns } from "./ArrowPlusUp.vue?vue&type=template&id=f42a41c4&scoped=true&"
import script from "./ArrowPlusUp.vue?vue&type=script&lang=js&"
export * from "./ArrowPlusUp.vue?vue&type=script&lang=js&"
import style0 from "./ArrowPlusUp.vue?vue&type=style&index=0&id=f42a41c4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42a41c4",
  null
  
)

export default component.exports